import React, { FC, useMemo, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import { DropDownOptions } from 'devextreme-react/select-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { MONEY_FORMAT } from 'constants/formats';
import { NumberBox, SelectBox, TextArea } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';

import {
  useChangeCashFlowExpenseFareDetailMutation,
  useCreateCashFlowExpenseFareDetailMutation,
  useLazyGetCashFlowExpenseFareDetailQuery,
} from 'bus/cash';
import { CashFlowExpenseFareDetailItem } from 'bus/cash/types/cashFlowExpenseFare';

type CreateEditModalProps = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
  id: number | null;
  cashFlowId: number;
};

const initialForm: CashFlowExpenseFareDetailItem = {
  transportId: null,
  cashFlowId: null,
  detailId: null,
  sum: 0,
  comment: '',
};

const CreateEditModal: FC<CreateEditModalProps> = ({ changeVisible, refresh, visible, id, cashFlowId }) => {
  let createGroupValidationRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<CashFlowExpenseFareDetailItem>(initialForm);

  const [loadCashFlowExpenseFare] = useLazyGetCashFlowExpenseFareDetailQuery();
  const [createCashFlowExpenseFare, { isLoading: isLoadingCreate }] = useCreateCashFlowExpenseFareDetailMutation();
  const [changeCashFlowExpenseFare, { isLoading: isLoadingChange }] = useChangeCashFlowExpenseFareDetailMutation();

  const disabledSubmit = isLoadingCreate || isLoadingChange;

  const onShown = async () => {
    if (id) {
      const result = await loadCashFlowExpenseFare({ cashFlowId, detailId: id });
      setForm(result.data!);
    } else {
      setForm(initialForm);
    }
  };

  const storeTransport: any = useMemo(() => {
    return $createDataSource('/v1/Transport', 'id');
  }, []);

  const onHidden = () => {
    setForm(initialForm);
    createGroupValidationRef.current?.instance.reset();
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      if (id) {
        await changeCashFlowExpenseFare({ ...form, cashFlowId, detailId: id });
      } else {
        await createCashFlowExpenseFare({ ...form, cashFlowId, detailId: id });
      }
      changeVisible(false);
      refresh();
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Расходы на запчасти"
        width={500}
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createGroupValidationRef}>
                <Form id="test-facrory" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Транспорт" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={storeTransport}
                            displayExpr="fullName"
                            valueExpr="id"
                            value={form.transportId}
                            searchEnabled
                            onItemClick={(e) => {
                              setForm((prev) => ({ ...prev, transportId: e.itemData.id }));
                            }}
                          >
                            <DropDownOptions title="Выберите Транспорт" closeOnOutsideClick={true} showTitle={false} />
                            <Validator>
                              <RequiredRule message="Выберите Транспорт" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>

                        <AppFiledBox label="Сумма, руб." labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="0"
                            format={MONEY_FORMAT}
                            value={form.sum}
                            onValueChanged={(e) => {
                              setForm((prev) => ({ ...prev, sum: e.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Сумма, руб." />
                            </Validator>
                          </NumberBox>
                        </AppFiledBox>

                        <AppFiledBox label="Комментарий" labelTop>
                          <TextArea
                            stylingMode="underlined"
                            placeholder="Введите комментарий"
                            mode="text"
                            value={form.comment || ''}
                            onChange={(e: any) => {
                              setForm((prev) => ({ ...prev, comment: e.event.currentTarget.value }));
                            }}
                          />
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={disabledSubmit}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CreateEditModal;
